import { FilterAlt } from '@mui/icons-material'
import { Box, Button, Typography } from '@mui/material'
import { memo, useCallback, useEffect, useState } from 'react'
import Icon from '../../components/icon'
import CustomTextField from '../../components/textfield'
import FilterModal from './FilterModal'

const TableHeader = ({ filters, handleChange, handleOpenCouponModal }) => {
  const [filterAnchorEl, setFilterAnchorEl] = useState(null)
  const [searchValue, setSearchValue] = useState(filters?.search || '')

  // Debounce search input
  useEffect(() => {
    const timer = setTimeout(() => {
      handleChange({ search: searchValue })
    }, 500)

    return () => clearTimeout(timer)
  }, [searchValue, handleChange])

  const openFilter = useCallback((e) => {
    setFilterAnchorEl(e.currentTarget)
  }, [])

  const closeFilter = useCallback(() => {
    setFilterAnchorEl(null)
  }, [])

  const handleFilterChange = useCallback(
    (data) => {
      handleChange(data)
      closeFilter()
    },
    [closeFilter, handleChange]
  )

  return (
    <Box px={2} pb={4} className="coupons-table-header">
      <Typography variant="h4">Coupons</Typography>

      <Box className="table-btn-container">
        <CustomTextField
          placeholder="Search Coupon..."
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
        />
        <Button
          variant="outlined"
          onClick={openFilter}
          startIcon={<FilterAlt sx={{ fontSize: '19px' }} />}
        >
          Filter
        </Button>

        <Button
          onClick={() => handleOpenCouponModal()}
          variant="contained"
          startIcon={
            <Icon icon={'ic:baseline-add'} style={{ fontSize: '18px' }} />
          }
        >
          New Coupon
        </Button>
      </Box>
      <FilterModal
        open={Boolean(filterAnchorEl)}
        anchorEl={filterAnchorEl}
        inputData={filters}
        handleClose={closeFilter}
        handleApplyClick={handleFilterChange}
      />
    </Box>
  )
}

export default memo(TableHeader)
